import { Heading } from 'blaze-ui/Heading/Heading'
import { ChevronRightSmall, Edit1, ImageAdd, Images, Templates, Trash2 } from 'blaze-ui/icons'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { ScheduledContent } from '../../ScheduleContent'
import { Key } from 'react'
import { useRootStore } from 'stores/RootStore'
import { EditKey } from './EditMenu'
import { Menu } from 'components/Menu/Menu'
import { Section } from '@react-stately/collections'
import { Item } from 'components/Menu/MenuItem'
import { ItemElement } from '@react-types/shared'

interface Props extends DrawerProps {
  content: ScheduledContent
  onAction: (key: Key, uuid: string) => void
}

export const EditDrawer = ({ content, onAction, ...props }: Props) => {
  const { closeDrawer } = useRootStore().drawersStore

  return (
    <Drawer.Root {...props}>
      <Drawer.Content>
        <Drawer.InnerContent>
          <Drawer.Top>
            <Drawer.Close label="Cancel" />
            <Drawer.Title asChild>
              <Heading level={5}>Edit Post</Heading>
            </Drawer.Title>
          </Drawer.Top>
          <Drawer.Container>
            <Menu
              menuType="tray"
              onAction={(key) => {
                closeDrawer()
                onAction(key, content.uuid)
              }}
            >
              <Section>
                {
                  [
                    content.hasReplaceableImage && !content.initialMediaFileId && (
                      <Item
                        key={EditKey.ChangeAddImage}
                        textValue="Add Image"
                        frontIcon={ImageAdd}
                        endIcon={ChevronRightSmall}
                      >
                        Add Image
                      </Item>
                    ),
                    content.hasReplaceableImage && content.initialMediaFileId && (
                      <Item
                        key={EditKey.ChangeAddImage}
                        textValue="Change Image"
                        frontIcon={Images}
                        endIcon={ChevronRightSmall}
                      >
                        Change Image
                      </Item>
                    ),
                    content.sourceVisualElementId && (
                      <Item
                        key={EditKey.ChangeTemplate}
                        textValue="Change Template"
                        frontIcon={Templates}
                        endIcon={ChevronRightSmall}
                      >
                        Change Template
                      </Item>
                    ),
                    <Item key={EditKey.EditCaption} textValue="Edit" frontIcon={Edit1} endIcon={ChevronRightSmall}>
                      Edit Caption
                    </Item>,
                    <Item key={EditKey.Delete} textValue="Delete" frontIcon={Trash2} endIcon={ChevronRightSmall}>
                      Delete
                    </Item>,
                  ].filter(Boolean) as ItemElement<HTMLElement>[]
                }
              </Section>
            </Menu>
          </Drawer.Container>
        </Drawer.InnerContent>
      </Drawer.Content>
    </Drawer.Root>
  )
}
